import beErrorMessages, { generalErrorMessage } from './beErrorMessages';
const getErrorMessage = (id) => !id || !beErrorMessages[id] ? generalErrorMessage : beErrorMessages[id];
export default getErrorMessage;
//# sourceMappingURL=getErrorMessage.js.map